<script lang="ts">
  export let properties: any = {};
</script>
